import { createFileRoute } from "@tanstack/react-router";
import BlogPost from "@/pages/BlogPost";
import { postBySlugQueryOptions } from "@/hooks/useBlog";
import { seoHead } from "@/lib/seoHead";

interface PostSeo {
  title?: string | null;
  excerpt?: string | null;
  seo_title?: string | null;
  seo_description?: string | null;
  featured_image_url?: string | null;
  canonical_slug?: string | null;
}

export const Route = createFileRoute("/$slug")({
  loader: async ({ params, context }) => {
    try {
      // Pré-carrega no servidor a mesma consulta que a página usa: o artigo já
      // sai renderizado no HTML, sem esperar o navegador.
      const post = await context.queryClient.ensureQueryData(
        postBySlugQueryOptions(params.slug),
      );
      return { post: (post ?? null) as PostSeo | null };
    } catch {
      return { post: null };
    }
  },
  // Mesmos valores do usePageSeo da página, agora renderizados no servidor.
  head: ({ loaderData, params }) => {
    const post = loaderData?.post;
    return seoHead({
      title: post?.seo_title || post?.title || "Blog | Shopping do Bem",
      description:
        post?.seo_description ||
        post?.excerpt ||
        "Dicas, cupons e novidades sobre compras online solidárias.",
      ogType: "article",
      canonical: post?.canonical_slug
        ? `https://shoppingdobem.com.br/${post.canonical_slug}`
        : `https://shoppingdobem.com.br/${params.slug}`,
      ogImage: post?.featured_image_url ?? null,
      noindex: !post,
    });
  },
  component: BlogPost,
});
